import inventoryText from "../inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";
import Select from "react-select";
import AuthContext from "../../context/AuthContext";

function AddWarehouse() {
  function refreshPage() {
    window.location.reload(false);
  }

  const [message, setMessage] = useState(null);

  let { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));
  const [name, setname] = useState("");
  const [manager, setmanager] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  let [employee, setemployee] = useState([]);
  const [accountHolders, setAccountHolders] = useState([]);

  const validate = () => {
    return (
      name !== "" &&
      manager !== "" &&
      accountHolder !== ""
    );
  };
  useEffect(() => {
    let isMounted = true;

    const getemployee = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/administration/employees/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
              "Content-Type": "application/json",
            },
            params: {
              username: "admin",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setemployee(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    const getAccountHolders = async () => {
      try {
        const response = await Axios.get(
          `${API_URL}/inventory/warehouses/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              type: "account_holders",
            },
          }
        );

        if (response.status === 200 && isMounted) {
          setAccountHolders(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    getemployee();
    getAccountHolders();

    return () => {
      isMounted = false;
    };
  }, []);

  const employees = employee.map((item) => {
    return {
      label: item.first_name,
      value: item.employee_id,
    };
  });

  const accountHolderOptions = accountHolders.map((item) => {
    return {
      label:
        item.name_en ||
        item.name_ar ||
        `Account Holder ${item.account_holder_id}`,
      value: item.account_holder_id,
    };
  });
  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Close the modal after 3 seconds
    setTimeout(() => {
      refreshPage();
    }, 1200);

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 1000);
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    Axios.post(
      `${API_URL}/inventory/warehouses/`,
      {
        Action: "Post",
        name: name,
        manager: manager,
        account_holder: accountHolder,
        userdealer: user.username,
      },
      {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
      }
    )
      .then((response) => {
        console.log(response);
        showMessage("Creation successful!", "success"); // Show the success message
      })
      .catch((error) => {
        console.log(error);
        showMessage("Creation failed!", "danger"); // Show the error message
      });
  };

  return (
    <div className="testi">
      <div className="mod">
        <form onSubmit={handleSubmit}>
          <div className="name">
            <div className="form-group">
              <label>{inventoryText("inventory.Name")}:<input
                  className="form-control"
                  type="text"
                  value={name}
                  required
                  onChange={(e) => setname(e.target.value)}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                {inventoryText("inventory.Manager")}:
                <Select
                  className="search-line"
                  classNamePrefix="product-edit-select"
                  required
                  options={employees}
                  onChange={(opt) => setmanager(opt.value)}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                {inventoryText("inventory.AccountHolder")}:
                <Select
                  className="search-line"
                  classNamePrefix="product-edit-select"
                  options={accountHolderOptions}
                  placeholder={inventoryText(
                    "inventory.SelectAccountHolder"
                  )}
                  onChange={(opt) =>
                    setAccountHolder(opt ? opt.value : "")
                  }
                />
              </label>
            </div>
          </div>

          <div className="fo">
            <button
              type="submit"
              className="btn purchase-button purchase-button-primary"
              disabled={!validate()}
            >{inventoryText("inventory.Create")}</button>
          </div>
        </form>
      </div>
      {/* Popup Message */}
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default AddWarehouse;
